import { devConfig } from './dev';
import { prodConfig } from './prod';
import { stageConfig } from './stage';
import { BaseConfig, Config, Environment, PlatformMode } from './types';

const configMap: Record<string, BaseConfig> = {
  [Environment.prod]: prodConfig,
  [Environment.stage]: stageConfig,
  [Environment.dev]: devConfig,
};

export const env: string = process.env['NEXT_PUBLIC_ENV'] || 'dev';

const requestedPlatformMode = process.env.NEXT_PUBLIC_PLATFORM_MODE;
const platformMode: PlatformMode =
  requestedPlatformMode === PlatformMode.archive ? PlatformMode.archive : PlatformMode.live;

export const config: Config = {
  ...configMap[env],
  platformMode,
};
